import React, { useEffect, useMemo, useState } from 'react'

export default function Timer() {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });

      useEffect(() => {
   

        const interval = setInterval(() => {
          const now = new Date().getTime();
          const endTime = new Date("2025-06-12T04:12:50.338Z").getTime();
          let t;
          t = endTime - now;
          if (t <= 0) {
            setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          } else {
            const days = Math.floor(t / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
              (t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((t % (1000 * 60)) / 1000);
            setTimeLeft({ days, hours, minutes, seconds });
          }
        }, 1000);
    
        return () => clearInterval(interval);
      
    }, []);
  
    const memoizedTimeLeft = useMemo(() => {
      return timeLeft;
    }, [timeLeft]);


  return(
   <>
    <div id="clockdiv">
          <div className="t_box">
            <span className="days" id="day" >{memoizedTimeLeft?.days}</span>
            <div className="smalltext">Days</div>
          </div>
          <div className="t_box">
            <span className="hours" id="hour" >{memoizedTimeLeft?.hours}</span>
            <div className="smalltext">Hours</div>
          </div>
          <div className="t_box">
            <span className="minutes" id="minute" >{memoizedTimeLeft?.minutes}</span>
            <div className="smalltext">Minutes</div>
          </div>
          <div className="t_box">
            <span className="seconds" id="second" >{memoizedTimeLeft?.seconds}</span>
            <div className="smalltext">Seconds</div>
          </div>
        </div>
   </>
  ) 
}
